import { Region } from '@/@types/generated'
import { register } from './enum'

export const RegionLabels: Record<Region, string> = {
  [Region.AUSTIN]: 'Austin',
  [Region.SAN_ANTONIO]: 'San Antonio',
  [Region.HOUSTON]: 'Houston',
  [Region.DALLAS]: 'Dallas',
  [Region.FORT_WORTH]: 'Fort Worth',
  [Region.WEST_TEXAS]: 'West Texas',
}

export const RegionNumber: Record<Region, string> = {
  [Region.AUSTIN]: '1',
  [Region.SAN_ANTONIO]: '2',
  [Region.HOUSTON]: '3',
  [Region.DALLAS]: '4',
  [Region.FORT_WORTH]: '5',
  [Region.WEST_TEXAS]: '6',
}

register<Region>(Region, (v) => {
  if (!v) return '\u2014'
  return `${RegionNumber[v]} - ${RegionLabels[v]}`
})
